import styled from 'styled-components';

export const StyledBodyWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledBlock = styled.div`
  border-radius: ${({ theme }): string => `${theme.spacers!.spacer04}`};
  background: white;
  width: 100%;
  box-shadow: 0 2px 12px -8px rgb(19 32 57 / 40%);
  padding: ${({ theme }): string => `${theme.spacers!.spacer05}`} ${({ theme }): string => `${theme.spacers!.spacer06}`};
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
